import React                     from 'react';
import is                        from 'is';
import { isNullOrUndefined }     from 'rewire-common';
import { Observe }               from 'rewire-core';
import { WithStyle }             from 'rewire-ui';
import Button                    from '@material-ui/core/Button';
import { Theme }                 from '@material-ui/core/styles';
import { withStyles }            from '../utility/styles';

export interface IViewTab {
  title:     string;
  content:   JSX.Element | string;
  visible?:  boolean | (() => boolean);
  disabled?: boolean | (() => boolean);

  onClick:   () => void;
}

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  viewButton: {
    borderRadius: 0,
    minWidth: '60px',
    border: `1px solid ${theme.palette.neutral.main}`,
    marginLeft: '-1px',
    marginTop: '-1px',
    '&$viewButtonDisabled': {
      pointerEvents: 'auto !important',
      backgroundColor: `${theme.palette.dialogPrimary.main}`,
      color: `${theme.palette.dialogPrimary.contrastText}`,
      '&:hover': {
        backgroundColor: `${theme.palette.dialogPrimary.main}`,
      },
    },
  },
  viewButtonDisabled: {
  },
});

interface IViewTabsProps {
  classes?: any;
  tabs:     IViewTab[];
}

type ViewTabsProps = WithStyle<ReturnType<typeof styles>, IViewTabsProps>;

class ViewTabs extends React.PureComponent<ViewTabsProps> {
  constructor(props: ViewTabsProps) {
    super(props);
  }

  render() {
    const {classes, tabs} = this.props;

    return <Observe render={() => (
      <div className={classes.root}>
        {tabs.map((tab: IViewTab, idx: number) => {
          const visible  = !!(tab.visible && is.function(tab.visible) ? (tab.visible as CallableFunction)() : !isNullOrUndefined(tab.visible) ? tab.visible : true);
          const disabled = !!(tab.disabled && is.function(tab.disabled) ? (tab.disabled as CallableFunction)() : tab.disabled);
          return (
            visible
              ? <Button
                  key={`${tab.title}::${idx}`}
                  variant='contained'
                  title={tab.title}
                  className={classes.viewButton}
                  classes={{disabled: classes.viewButtonDisabled}}
                  disabled={disabled}
                  onClick={tab.onClick}
                >{tab.content}</Button>
              : null
          );
        })}
      </div>
    )} />;
  }
}

export default withStyles<IViewTabsProps>(styles, ViewTabs);
